import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getAllSettingTolid } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import FormTolid from "./components/FormTolid/FormTolid";
import Translator from "Languages/Utility/Translator";

function TolidSettings() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllSettingTolid(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-4">
        <PageTitle title={<Translator id={"productionReportSettings"} />} />
      </div>
      <MuiPaper>
        <FormTolid />
      </MuiPaper>
    </Fragment>
  );
}

export default TolidSettings;
